import CloseIcon from '@mui/icons-material/Close'
import { IconButton, SxProps, Theme, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface ClearButtonProps {
  tooltipKey: 'clearButton.value' | 'clearButton.selection'
  onClick: () => void
  sx?: SxProps<Theme>
}

export function ClearButton({ tooltipKey, onClick, sx }: ClearButtonProps) {
  const { t } = useTranslation('@cibo/ui/Uniforms')

  return (
    <Tooltip title={t(tooltipKey)}>
      <IconButton
        aria-label={t('clear')}
        data-testid="clear-button"
        onClick={onClick}
        size="small"
        sx={sx}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}
